import { createRouter, createWebHistory } from 'vue-router'

import Error404View from '../views/Error404View.vue'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import PreRegisterView from '../views/PreRegisterView.vue'
import ActiveRegisterView from '../views/ActiveRegisterView.vue'
import ForgotPasswordView from '../views/ForgotPasswordView.vue'
import SendActivateView from '../views/SendActivateView.vue'
import ActivateView from '../views/ActivateView.vue'
import CreateWalletView from '../views/CreateWalletView.vue'
import NotificationsView from '../views/NotificationsView.vue'
import SettingsView from '../views/SettingsView.vue'
import PagesView from '../views/PagesView.vue'
import SupportView from '../views/SupportView.vue'

import TransactionsView from '../views/TransactionsView.vue'
import HistoryView from '../views/HistoryView.vue'

import CryptoIndexView from '../views/crypto/IndexView.vue'
import CryptoPortfolioView from '../views/crypto/PortfolioView.vue'
import CryptoTransactionsView from '../views/crypto/TransactionsView.vue'
import CryptoExchangeView from '../views/crypto/ExchangeView.vue'

import SettingsMobileView from '../views/settings/MobileView.vue'
import ValidateMobileView from '../views/validate/MobileView.vue'

import SettingsFA2View from '../views/settings/FA2View.vue'
import ValidateFA2View from '../views/validate/FA2View.vue'

import ReferView from '../views/ReferView.vue'
import SettingsBanksView from '../views/settings/BanksView.vue'
import SettingsChangePasswordView from '../views/settings/ChangePasswordView.vue'

import VerifyDepositView from '../views/verify/DepositView.vue'
import VerifyBlockingView from '../views/verify/BlockingView.vue'
import WithdrawBlockingView from '../views/Withdraw/BlockingView.vue'
import CanceledBlockingView from '../views/canceled/BlockingView.vue'
import VerifyWithdrawView from '../views/verify/WithdrawView.vue'
import VerifyTxInternal from '../views/verify/TxInternal.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/verify/deposit/:network_id/:asset_id',
    name: 'verify-deposit',
    component: VerifyDepositView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/verify/blocking/:network_id/:asset_id/:amount/:time_lock',
    name: 'verify-blocking',
    component: VerifyBlockingView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/verify/withdraw/:network_id/:asset_id/:amount/:to',
    name: 'verify-withdraw',
    component: VerifyWithdrawView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/verify/txinternal/:network_id/:asset_id/:amount/:to',
    name: 'verify-txinternal',
    component: VerifyTxInternal,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/canceled/blocking/:tx_id',
    name: 'canceled-blocking',
    component: CanceledBlockingView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/withdraw/blocking/:tx_id',
    name: 'withdraw-blocking',
    component: WithdrawBlockingView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/history',
    name: 'history',
    component: HistoryView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/transactions',
    name: 'transactions',
    component: TransactionsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: NotificationsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/change-password',
    name: 'settings-change-password',
    component: SettingsChangePasswordView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/banks',
    name: 'settings-banks',
    component: SettingsBanksView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/mobile',
    name: 'settings-mobile',
    component: SettingsMobileView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/validate-mobile',
    name: 'validate-mobile',
    component: ValidateMobileView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/fa2',
    name: 'settings-fa2',
    component: SettingsFA2View,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/validate-fa2',
    name: 'validate-fa2',
    component: ValidateFA2View,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/refer',
    name: 'refer',
    component: ReferView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/support',
    name: 'support',
    component: SupportView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/create-wallet',
    name: 'create-wallet',
    component: CreateWalletView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/crypto/index',
    name: 'crypto-index',
    component: CryptoIndexView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/crypto/portfolio',
    name: 'crypto-portfolio',
    component: CryptoPortfolioView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/crypto/exchange',
    name: 'crypto-exchange',
    component: CryptoExchangeView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/crypto/transactions',
    name: 'crypto-transactions',
    component: CryptoTransactionsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/pages',
    name: 'pages',
    component: PagesView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: '/active-register',
    name: 'active-register',
    component: ActiveRegisterView,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: '/pre-register',
    name: 'pre-register',
    component: PreRegisterView,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: '/activate',
    name: 'activate',
    component: ActivateView,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: '/send-activate',
    name: 'send-activate',
    component: SendActivateView,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPasswordView,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: '/*',
    name: 'error-404',
    meta: {
      requiresAuth: false,
      requiresGuest: false,
    },
    component: Error404View,
  },
  {
    path: '/about',
    name: 'about',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ContactView.vue')
    }
  },
  {
    path: '/faq',
    name: 'faq',
    component: function () {
      return import('../views/FaqView.vue')
    }
  },
  {
    path: '/404',
    name: '404',
    component: function () {
      return import('../views/errors/404View.vue')
    }
  },
  {
    path: '/splash',
    name: 'splash',
    component: function () {
      return import('../views/SplashView.vue')
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
